import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

import { IonSelectOption, IonSelect, SelectCustomEvent } from "@ionic/vue";
import { ref, computed, watch } from "vue";
import { t } from "@/plugins/vue-i18n";
import { useField } from "vee-validate";

import { getOptions } from "@/functions/converter";

import { ION_MODE, ION_SELECT_INTERFACE, LABEL_POSITION } from "@/types/enum/ionicEnum";
import { SelectBaseProps } from "@/types/props";
import { SelectBaseEmits } from "@/types/emits";
import { SelectOption } from "@/types/others";


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectSimple',
  props: {
    cancelText: {},
    compareWith: {},
    disabled: { type: Boolean },
    interface: { default: ION_SELECT_INTERFACE.ACTION_SHEET },
    interfaceOptions: { default: () => {
        return { mode: ION_MODE.IOS }
    } },
    mode: {},
    modelValue: {},
    multiple: { type: Boolean },
    name: {},
    okText: { default: t('button.ok') ?? 'Ok' },
    options: {},
    placeholder: { default: 'Auswählen' },
    selectedText: {},
    validateOption: {},
    valueKey: { default: 'value' },
    textKey: { type: [String, Function], default: 'text' },
    position: { default: LABEL_POSITION.STACKED },
    lines: { default: 'none' },
    selectClass: {}
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

// Vee-Validate Composable
const {
    name,
    handleChange,
    handleBlur,
    validate
} = useField(
    props.validateOption?.name ?? '',
    props.validateOption?.rules ?? '',
    {
        valueProp: props.modelValue,
        initialValue: JSON.parse(JSON.stringify(props.modelValue ?? '')),
        label: props.validateOption?.label ?? props.validateOption?.name,
        ...props.validateOption?.options
    }
)

const cancelTextRef = ref<string>(props.cancelText ?? t('button.cancel'))

const parsedOptions = computed<SelectOption[]>(() => {
    if (!props.options) return []
    const textKey = props.textKey
    const valueKey = props.valueKey
    return getOptions(props.options, valueKey, textKey)
})

const handlerChange = (event: SelectCustomEvent): void => {
    emit('update:modelValue', event.detail.value);
    handleChange(event);
    emit('change', event.detail.value)
}

watch(props, () => {
    if (props.modelValue) handleChange(props.modelValue)
})

window.addEventListener('change-language', () => {
    validate({ mode: 'force' })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonSelect), {
    class: _normalizeClass(["select-simple light-grey4-background purple-purple-color", __props.selectClass]),
    "cancel-text": cancelTextRef.value,
    compareWith: __props.compareWith,
    disabled: __props.disabled,
    interface: __props.interface,
    "interface-options": __props.interfaceOptions,
    mode: __props.mode,
    multiple: __props.multiple,
    name: _unref(name),
    "ok-text": __props.okText,
    placeholder: __props.placeholder,
    "selected-text": __props.selectedText,
    value: __props.modelValue,
    onIonChange: handlerChange,
    onIonBlur: _unref(handleBlur)
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "options", {}, () => [
        (parsedOptions.value)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(parsedOptions.value, (option) => {
              return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                key: option.value,
                value: option.value,
                disabled: option.disabled
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(option.text), 1)
                ]),
                _: 2
              }, 1032, ["value", "disabled"]))
            }), 128))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 3
  }, 8, ["class", "cancel-text", "compareWith", "disabled", "interface", "interface-options", "mode", "multiple", "name", "ok-text", "placeholder", "selected-text", "value", "onIonBlur"]))
}
}

})